<template>
	<div ref="line" :style="lineStyle"></div>
</template>

<script>
//vuex
import {mapState} from 'vuex'
let echarts = require('echarts/dist/echarts.simple.min');
	let chart = null
	export default {
		name: 'MonLineChart',
		props: ['lineInfo'],
		computed: {
			lineStyle: function() {
				return {
					width: '100%',
					height: '100%'
				}

			},
			...mapState({
		  		currentIndex:state => state.home.currentIndex,
		  		curSubTab:state=>state.home.curSubTab
		  	})
		},
		watch:{
			currentIndex(val){
				if(val.indexOf('file') != -1){
					chart.resize()
					this.initChart()
				}
			},
			curSubTab(val){
		  		if(val=='detailHome'){
		  			chart.resize()
		  			this.initChart()
		  		}
		  	}
		},
		mounted(){
			this.initChart()
		},
		methods:{
			initChart(){
				chart = echarts.init(this.$refs.line);
			  	let lineData = [];
			  	let lineTitle = [];
			  	this.lineInfo.forEach(function(item, i) {
			  		lineData.push(item.mileage);
			  		lineTitle.push(item.yearMonth)
			  	})
				chart.setOption({
				  		title:{
				  			text:'新增车辆数量',
				  			textBaseline:'middle'
				  		},
				  		grid:{
				  			left:'8%',
				  			right:'2%',
				  			top:'10%',
				  			bottom:'10%'
				  		},
				  		xAxis:[
				  			{
				  				type:'category',
				  			//	boundaryGap:false,
				  				data:lineTitle,
				  				axisTick:{
				  					show:false//不显示坐标轴刻度
								},
								axisLine:{
									lineStyle:{
										color:'#bbb'
									}
								}  
				  			}
				  		],
				  		yAxis:[
				  			{
				  				type:'value',
				  				minInterval: 1,
				  				min:0,
				  				axisLine:{
									lineStyle:{
										color:'#bbb'
									},
				  					show:false//不显示坐标轴
				  				}
				  			}
				  		],
				  		series:[
				  			{
				  				name:'',
				  				type:'line',
								  symbol:'emptycircle',
								  symbolSize:10,
				  				label:{
				  					normal:{
				  						show:true,
				  						position:'top',
				  						textStyle:{
				  							color:'#000'
				  						},
				  						formatter: '{c}km'
				  					}
								  },
								itemStyle:{
									normal:{
										color:"#1AB394",
										borderWidth:2
									}
								},  
				  				smooth:true,//显示平滑曲线
				  				lineStyle:{
				  					normal:{
				  						color:'#1AB394',
				  						width:3
				  					}
				  				},
				  				data:lineData
				  			}
				  		]
				});
				$(window).resize(chart.resize);
			}
		}
	}
</script>


// WEBPACK FOOTER //
// MonLineChart.vue?31e3787b